import { DataTable } from '@r/components/data-table/data-table.tsx';
import { useDataTable } from '@r/hooks/use-data-table.ts';
import { Fragment, type FC } from 'react';
import { useTargetColumns } from './hooks/use-target-columns.tsx';
import { CreateTargetDialog } from './create-target-dialog.tsx';
import { type LogicType, LogicTypes, type TargetLogicType } from '@admin/types/workspace/logic.ts';
import type { LogicTypeTargetWorkspaceWriteModel } from '@r/api/generated/client.schemas.ts';

type Target = LogicTypeTargetWorkspaceWriteModel & {
  logicTargetType?: TargetLogicType;
};

interface TargetTableProps {
  data: Target[];
  setData: (type: LogicType, targets: Target[]) => void;
}

export const TargetTable: FC<TargetTableProps> = ({ data, setData }) => {
  const { table } = useDataTable({
    data: data ?? [],
    columns: useTargetColumns(),
    pageCount: 1
  });

  // Récupérer le type du premier target (si existe)
  const firstTargetType = data.length > 0 ? data[0]?.logicTargetType : undefined;

  const onCreated = async (targets: Target) => {
    // Si c'est le premier target, on utilise son type
    // Sinon, on force le même type que le premier
    const targetWithType: Target = {
      ...targets,
      logicTargetType: firstTargetType || targets.logicTargetType
    };
    setData(LogicTypes.TARGETS, [...data, targetWithType]);
  };

  return (
    <Fragment>
      <DataTable table={table} pagination={false} />
      <CreateTargetDialog onTargetCreated={onCreated} fixedType={firstTargetType} />
    </Fragment>
  );
};
